// 外部可读取的订单元数据
// 使用方式：import orders from '@/page/train/FBT/data/order';

const orders = {
    "douyin": [
        {
            'id': 1001 ,
            'productName': '【22包】帮宝适黑金帮尿不湿夏季透气亲肤纸尿裤拉拉裤ZC [快照]',
            'address': '吉林省长春市宽城区兰家镇**********',
            'phone': '1*********',
            'name': '李*',
            'size': '摇摇车(莫奈绿-A1 旗舰款)/黑金帮纸尿裤L32片*4包+赠黑金帮安睡拉拉裤甄选装L19片*1包(推荐18-28斤)/18包',
            'num': '1',
            'price': 2618,
            'lastprice': 2603,
            'youfei': '',
            'status': '待发货',
            'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs1.png',
            'actionType': '',
            'remark': ''
        },

        {
            'id': 1002 ,
            'productName': '【护臀级】帮宝适一级帮纸尿裤超薄透气NB-M尿不湿添加类胎脂清爽 [快照]',
            'address': '安徽省宣城市宣州区金坝街道*********',
            'phone': '1*********',
            'name': '小*',
            'size': '【 新人尝鲜】纸尿裤NB29片/包（5kg以下）',
            'num': '1',
            'price': 29.9,
            'lastprice': 29.9,
            'youfei': '',
            'status': '已退款',
            'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs2.png',
            'actionType': '',
            'remark': ''
        },

        {
            'id': 1003 ,
            'productName': '【暖暖专属】帮宝适清新帮夏日透气干爽纸尿裤拉拉裤尿不湿NB-3XL [快照]',
            'address': '辽宁省沈阳市铁西区沈阳市经济技术开发区*********',
            'phone': '1*********',
            'name': '刘*',
            'size': '拉拉裤XXL28片*3包【推荐30斤以上】',
            'num': '1',
            'price': 174,
            'lastprice': 174,
            'youfei': '',
            'status': '已退款',
            'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs3.png',
            'actionType': '',
            'remark': ''
        },

        {
            'id': 1004 ,
            'productName': '【超品狂欢立即付定金】帮宝适黑金帮纸尿裤拉拉裤添加真蚕丝尿不湿 [快照]',
            'address': '四川省绵阳市游仙区小枧镇***************',
            'phone': '1*********',
            'name': '晨*',
            'size': '手拍鼓手摇铃礼盒六件套/新升级！【纸尿裤】M34片*6包（6-11kg，共204片）',
            'num': '1',
            'price': 627,
            'lastprice': 627,
            'youfei': '',
            'status': '待发货',
            'imgurl': 'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/bbs4.png',
            'actionType': '',
            'remark': ''
        },
        //====================抖音美的售前售后实操案例==================
        {
            'id':1011,
            'productName':'【国补20%】华凌空调1.5匹超省电Pro变频一级WiFi智能',
            'address':'山东省济南市槐荫区腊山街道东湖小区',
            'phone':'13345454545',
            'name':'小王',
            'size':'大1.5匹：KFR-35GW/N8HA1Ⅲ-P',
            'num':1,
            'price':1649,
            'lastprice':1319.2,
            'youfei':0.8,
            'status':'未付款',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd1.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1012,
            'productName':'【国补20%】神机二代华凌空调1.5匹35HE1Ⅱ Pro一级变频WiFi智能',
            'address':'河北省保定市定州市南城区街道135号',
            'phone':'13588888888',
            'name':'小涛',
            'size':'大1.5匹：KFR-35GW/N8HE1Ⅱ',
            'num':1,
            'price':2299,
            'lastprice':1839.2,
            'youfei':0.8,
            'status':'未付款',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd2.png',
            'actionType':'',
            'remark':''
        },

        {
            'id':1013,
            'productName':'【国补20%】神机二代华凌空调1.5匹挂机35HE1Ⅱ超一级变频智能 [快照]',
            'address':'广东省佛山市顺德区伦教街道幸福小区',
            'phone':'15625252525',
            'name':'王雪',
            'size':'大1.5匹：KFR-35GW/N8HE1Ⅱ',
            'num':1,
            'price':2299,
            'lastprice':2155,
            'youfei':'平台优惠',
            'status':'未发货',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd3.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1014,
            'productName':'【国补】美的WAHIN冰箱589大容量精细分储一级风冷无霜变频轻音',
            'address':'山东省济宁市任城区丰泰园北区19号',
            'phone':'15255555555',
            'name':'邵晓',
            'size':'默认',
            'num':1,
            'price':1999,
            'lastprice':1599.2,
            'youfei':400,
            'status':'未发货',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd4.png',
            'actionType':''
        },
        {
            'id':1015,
            'productName':'【国补20%】华凌空调1.5匹超省电Pro变频一级WiFi智能 [快照]',
            'address':'湖南省永州市江华瑶族自治县白芒营镇3号',
            'phone':'198****0567',
            'name':'安琪拉',
            'size':'一级能耗挂机',
            'num':1,
            'price':1699,
            'lastprice':1659,
            'youfei':40,
            'status':'已发货',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd5.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1016,
            'productName':'【国补20%】神机二代华凌空调1.5匹35HE1Ⅱ Pro一级变频WiFi智能',
            'address':'湖南省长沙市天门区魔仙堡街',
            'phone':'198****0567',
            'name':'安琪拉',
            'size':'大1.5匹：KFR-35GWN8HL1Pro',
            'num':1,
            'price':2799,
            'lastprice':2239,
            'youfei':'8折',
            'status':'已关闭',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd6.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1017,
            'productName':'【国补8折】神机二代华凌空调1.5匹挂机35HE1Ⅱ超一级变频智能',
            'address':'湖南省长沙市天门区魔仙堡街',
            'phone':'198****0567',
            'name':'安琪拉',
            'size':'大1.5匹：KFR-35GW/N8HE1Ⅱ',
            'num':1,
            'price':2499,
            'lastprice':1519.2,
            'youfei':979.8,
            'status':'已签收',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/dymd7.png',
            'actionType':'',
            'remark':''
        }
    ],

    "jingmai": [
        //====================京东华凌售后实操案例==================
        {
            id: 1101,
            productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
            address: '广东湛江市赤坎区南桥街道',
            phone: '18666746871',
            name: '周弘',
            size: '(无)',
            num: 1,
            price: 2299,
            lastprice: 1874,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm1.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1102,
            productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
            address: '四川眉山市',
            phone: '18328118480',
            name: '琦',
            size: '(无)',
            num: 1,
            price: 2099,
            lastprice: 2093,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm2.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1103,
            productName: '华凌空调 大1.5匹 【大风口】双排神机二代变频冷暖挂机 超一级能效 KFR-35GW/N8HE1Ⅱ 家电国家补贴',
            address: '广东茂名市高州市',
            phone: '13790916882',
            name: '甘',
            size: '(无)',
            num: 1,
            price: 1899,
            lastprice: 1740,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm3.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1104,
            productName: '华凌空调 大1.5匹 【大风口】双排神机二代变频冷暖挂机 超一级能效 KFR-35GW/N8HE1Ⅱ 家电国家补贴',
            address: '广东惠州市',
            phone: '13790916882',
            name: '韦*',
            size: '(无)',
            num: 1,
            price: 2899,
            lastprice: 2319,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm4.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1105,
            productName: '华凌空调 新一级变频冷暖 大风口 1.5匹 客厅卧室挂式空调挂机 智能 升级电量查询 KFR-35GW/N8HL1Pro 以旧换新',
            address: '广东湛江市',
            phone: '13790916882',
            name: '黄*',
            size: '(无)',
            num: 1,
            price: 2029,
            lastprice: 1979,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm5.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1106,
            productName: '华凌空调 2匹 超省电 新一级 大风量 智能互联 卧室客厅空调挂机 以旧换新 KFR-50GW/N8HL1 家电国家补贴',
            address: '河南安阳市',
            phone: '18530622583',
            name: '王**',
            size: '(无)',
            num: 1,
            price: 2599,
            lastprice: 2070,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm6.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1107,
            productName: '华凌空调 2匹 超省电 新一级 大风量 智能互联 卧室客厅空调挂机 以旧换新 KFR-50GW/N8HL1 家电国家补贴',
            address: '河北石家庄',
            phone: '18530622583',
            name: '刘*',
            size: '(无)',
            num: 1,
            price: 5199,
            lastprice: 5199,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm7.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1108,
            productName: '华凌空调 神机二代 3匹 超一级能效 变频冷暖 客厅圆柱立式柜机 KFR-72LW/N8HE1Ⅱ 家电国家补贴 以旧换新',
            address: '江苏南通市',
            phone: '18530622583',
            name: '雯*',
            size: '(无)',
            num: 1,
            price: 5199,
            lastprice: 5199,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm8.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1109,
            productName: '华凌空调 新一级能效 变频冷暖 超大风口 1.5匹 客厅卧室空调挂机 升级电量查询 KFR-35GW/N8HE1Pro',
            address: '江西赣州市',
            phone: '18530622583',
            name: '华*',
            size: '(无)',
            num: 1,
            price: 2199,
            lastprice: 2199,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm9.png',
            actionType: '',
            remark: ''
        },
        {
            id: 1110,
            productName: '华凌空调 大1.5匹 新一级能效 超省电Pro 巨省电 变频冷暖空调挂机 KFR-35GW/N8HA1Ⅲ-P 家电国家补贴',
            address: '湖南岳阳市',
            phone: '18530622583',
            name: '魏*',
            size: '(无)',
            num: 1,
            price: 1599,
            lastprice: 1599,
            youfei: '',
            status: '已签收',
            imgurl: 'https://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/hljm9.png',
            actionType: '',
            remark: ''
        },
        //====================京东美的售后实操案例==================
        {
            'id':1121,
            'productName':'美的空调 大1.5匹 酷省电pro 新一级能效 变频冷暖 家电国家补贴 节能壁挂式挂机 KFR-35GW/N8KS1-1P',
            'address':'福建福州市仓山区建新镇福湾新城春风苑*区-14号楼**1',
            'phone':'1******3271',
            'name':'张栋义',
            'size':'大1.5匹 一级能效 酷省电pro',
            'num':1,
            'price':2799,
            'lastprice':2369,
            'youfei':8,
            'status':'待收货',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou1.png',
            'actionType':'',
            'remark':''
        },

        {
            'id':1122,
            'productName':'美的空调 大1.5匹 全面风PRO 风尊二代 家电国家补贴20%空调挂机 超一级能效 KFR-35GW/N8MXC1ⅡPro',
            'address':'江苏苏州市吴江区江陵街道江陵东路599号璀璨**花园2栋一单元6*1',
            'phone':'17851741124-2415',
            'name':'杨女士',
            'size':'大1.5匹 一级能效 风尊二代PRO',
            'num':1,
            'price':3699,
            'lastprice':3584.2,
            'youfei':8,
            'status':'已完成',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou2.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1123,
            'productName':'美的空调挂机大1.5匹 酷省电Ultra新一级能效变频冷暖以旧换新国家补贴【25年新品】KFR-35GW/N8KS1-1U',
            'address':'湖北武汉市蔡甸区**街道秦*路60号',
            'phone':'17834774515-2631',
            'name':'周峰',
            'size':'大1.5匹 一级能效 酷省电ultra',
            'num':1,
            'price':2769,
            'lastprice':2620.55,
            'youfei':null,
            'status':'已完成',
           'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou3.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1124,
            'productName':'美的大1.5匹 风尊二代PRO 2024新款 超一级能效空调挂机 安睡 家电政府补贴 KFR-35GW/N8MXC1ⅡPro',
            'address':'广东惠州市惠*区江北街道金**1栋2603室',
            'phone':'17834774515-2631',
            'name':'明镜',
            'size':'大1.5匹 一级能效 全新风尊二代PRO',
            'num':1,
            'price':3900,
            'lastprice':2499.36,
            'youfei':8,
            'status':'已完成',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou4.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1125,
            'productName':'美的空调 大1匹 酷省电 新一级能效 变频冷暖 壁挂式小空调挂机节能 家电国家补贴 KFR-26GW/N8KS1-1',
            'address':'湖南长沙市岳麓区**洲街道湖南大学阜**小区',
            'phone':'18472749095-6063 ',
            'name':'西西',
            'size':'大1匹 一级能效 酷省电',
            'num':1,
            'price':2099,
            'lastprice':1749,
            'youfei':null,
            'status':'已完成',
           'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou5.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1126,
            'productName':'美的空调 大1.5匹 酷省电 新一级能效 变频冷暖 省电壁挂式卧室挂机 国家补贴 KFR-35GW/N8KS1-1 ',
            'address':' 广东清远市清城区洲*街道***家11栋11栋6A',
            'phone':'17820056315-1257 ',
            'name':'朱先去',
            'size':'大1.5匹 一级能效 酷省电',
            'num':1,
            'price':2099,
            'lastprice':1778.92,
            'youfei':null,
            'status':'已完成',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou6.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1127,
            'productName':'美的（Midea）大1匹 变频 智弧 冷暖 智能壁挂式空调 KFR-26GW/WDAA3@',
            'address':'山东聊城市临清市城区车营城***(温泉路北100米)车***花园10号楼3单元802',
            'phone':'18472749095-6063 ',
            'name':'王立民',
            'size':'大1匹',
            'num':1,
            'price':2399,
            'lastprice':2399,
            'youfei':0,
            'status':'已完成',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou7.png',
            'actionType':'',
            'remark':''
        },
        {
            'id':1128,
            'productName':'美的空调 大1.5匹 酷省电pro 新一级能效 变频冷暖 家电国家补贴 节能壁挂式挂机 KFR-35GW/N8KS1-1P',
            'address':'四川眉山市彭山区锦江镇莲花村恒大金碧***栋1503房',
            'phone':'17834774634-6323 ',
            'name':'杨小虎',
            'size':'大1.5匹 一级能效 酷省电pro',
            'num':1,
            'price':2679,
            'lastprice':2668.2,
            'youfei':null,
            'status':'已完成',
            'imgurl':'http://res.study.itaojin.cn/training-resource/2025-09/Orderimgs/jdmdshouhou8.png',
            'actionType':'',
            'remark':''
        }



]

}


export default orders;


// WEBPACK FOOTER //
// ./src/page/train/FBT/data/order.js